<template>
  <div>
    <div class="search flex">
      <span class="tit">会诊管理</span>
      <div class="flex">
        <el-button size="mini" @click="addConsultation" class="addBtn">新增会诊</el-button>
        <el-input class="addART"
                  placeholder="会诊名称"
                  v-model="page.name"
                  @change="skipPage(1)"
                  suffix-icon="el-icon-search">
        </el-input>
      </div>
    </div>
    <div class="typeHead">
      <div class="medicineType flex">
        <span class="typeTit">筛选：</span>
        <div class="medicineTypeL">
          <span><label :class="active=='1'?'activeClass':''" @click="changePageType(1)">全部</label></span>
          <span><label :class="active=='2'?'activeClass':''" @click="changePageType(2,1)">发布中</label></span>
          <span><label :class="active=='3'?'activeClass':''" @click="changePageType(3,0)">未发布</label></span>
        </div>
      </div>
    </div>
    <div class="instrument mt-5">
      <el-table :data="page.rows" class="record-table"
                :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                height="calc(100vh - 375px)"
                max-height="calc(100vh - 375px)">
        <el-table-column prop="title" label="标题" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="subTitle" label="副标题" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
                   <span slot-scope="scope" class="common" :class="scope.row.status == 0?'yellow':'green'"
                         @click="changeStatus(scope.row)">
                        {{ scope.row.status | statusFmt }}
                    </span>
        </el-table-column>
        <el-table-column prop="meetStartDate" label="开始时间" width="150" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.meetStartDate | dateFmt }}</template>
        </el-table-column>
        <el-table-column prop="meetEndDate" label="结束时间" width="150" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.meetEndDate | dateFmt }}</template>
        </el-table-column>
        <el-table-column prop="deadlineDate" label="截止时间" width="170" align="center">
          <template slot-scope="scope">{{ scope.row.deadlineDate | dateFmt }}</template>
        </el-table-column>
        <el-table-column prop="registerCount" label="报名人数" width="100" align="center">
          <template slot-scope="scope">
            <el-button @click="showRegister(scope.row)" class="btn" type="text">
              {{ scope.row.registerCount }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button @click="toDetails(scope.row.id)" class="btn" type="text" size="small">详情</el-button>
            <el-button @click="toEdit(scope.row.id)" class="btn" type="text" size="small">编辑</el-button>
            <el-button @click="del(scope.row.id)" class="btn" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 20px"
                     class="pagination"
                     :hide-on-single-page="true"
                     background
                     prev-text="Prev"
                     next-text="Next"
                     @current-change="skipPage"
                     :current-page="page.current"
                     :page-size="page.size"
                     layout="prev, pager, next"
                     :total="page.total">
      </el-pagination>
    </div>
    <!-- 报名人员table -->
    <el-drawer title="已报名人员列表" :visible.sync="userListDialog" @close="userPage.mid=''"
               :show-close="false" size="1000px" class="drawerCommon" :close-on-press-escape="false">
      <el-table :data="userPage.rows" class="record-table"
                height="calc(100vh - 130px)"
                max-height="calc(100vh - 130px)"
                :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}">
        <el-table-column prop="name" label="姓名" align="center"></el-table-column>
        <el-table-column prop="userType" label="类型" width="100" align="center">
          <template slot-scope="scope">{{ scope.row.userType == 1 ? '用户' : scope.row.userType == 2 ? '医生' : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="gender" label="性别" width="80" align="center">
          <template slot-scope="scope">{{ scope.row.gender == 1 ? '男' : scope.row.gender == 0 ? '女' : '-' }}</template>
        </el-table-column>
        <el-table-column prop="age" label="年龄" width="80" align="center"></el-table-column>
        <el-table-column prop="mobile" label="手机" width="140" align="center"></el-table-column>
        <el-table-column prop="email" label="邮箱" align="center"></el-table-column>
        <el-table-column prop="abodeCity" label="所在城市" align="center"></el-table-column>
        <el-table-column prop="occupation" label="职业"></el-table-column>
        <el-table-column prop="registerDate" label="报名时间" width="140" align="center">
          <template slot-scope="scope">{{ scope.row.registerDate | dateFmt }}</template>
        </el-table-column>
      </el-table>
      <div style="text-align: center;margin-top: 8px;">
        <el-pagination
            class="pagination"
            :hide-on-single-page="true"
            background
            prev-text="Prev"
            next-text="Next"
            @current-change="skipUserPage"
            :current-page="userPage.current"
            :page-size="userPage.size"
            layout="total, prev, pager, next"
            :total="userPage.total">
        </el-pagination>
      </div>
    </el-drawer>
    <!-- edit dialog -->
    <el-drawer :title="editDialogTitle"
               :visible.sync="editDialog" :wrapperClosable="false"
               :show-close="false" size="800px" class="drawerCommon" :close-on-press-escape="false"
               @open="handleOpen"
               @close="clearForm">
      <el-form :model="editForm" label-suffix="：" label-width="100px" class="maxHeight">
        <el-form-item label="标题">
          <el-input v-model="editForm.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="副标题">
          <el-input v-model="editForm.subTitle" placeholder="请输入副标题"></el-input>
        </el-form-item>

        <el-form-item label="缩略图">
          <el-upload name="uploadFile"
                     :action="uploadUrl"
                     :accept="'image/*'"
                     :show-file-list="false"
                     :on-success="handleUploadSuccess"
                     :on-error="handleUploadError"
                     class="avatar-uploader">
            <img v-if="editForm.thumbnailPath" :src="editForm.thumbnailPath" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="会诊时间">
          <el-date-picker
              v-model="editForm.dateRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="截止时间">
          <el-date-picker v-model="editForm.deadlineDate" type="datetime"
                          placeholder="选择报名截止时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="会诊医生">

          <!--<span style="cursor: pointer;vertical-align: sub;" @click="doctorSelectDialog = true">
              <i class="el-icon-circle-plus-outline" style="font-size: 24px; color: #409eff;"></i>
          </span>

          <span class="user_item" v-for="doctor in editForm.doctors" :key="doctor.id">
              <span>{{doctor.fullName}}</span>
              <i class="el-icon-delete" @click="removeDoctor(doctor.id)"></i>
          </span>-->
          <el-select v-model="editForm.doctors" filterable multiple placeholder="请选择医生">
            <el-option
                v-for="item in doctors"
                :key="item.id"
                :label="item.fullName + ' (' + item.account + ')'"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会诊地点">
          <el-input v-model="editForm.meetPlace" type="datetime" placeholder="请输入会诊地点"></el-input>
        </el-form-item>
        <el-form-item label="简介">
          <el-input type="textarea" rows="3" v-model="editForm.briefDesc" placeholder="简介"></el-input>
        </el-form-item>
        <el-form-item label="说明" class="quill_parent" style="height: 460px;">
          <quill-editor style="height: 400px" v-model="editForm.explanation" @ready="quillEditorReadyHandle"
                        :options="editorOption" ref="myQuillEditor"></quill-editor>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button size="small" type="primary" @click="save">保存</el-button>
        <el-button size="small" @click="editDialog=false">取消</el-button>
      </div>

      <!-- select doctor -->
      <!--<el-dialog title="选择医生" :visible.sync="doctorSelectDialog" append-to-body width="400px">

          <el-button type="primary">确定</el-button>
      </el-dialog>-->

    </el-drawer>
    <div style="display: none">
      <input type="file" id="quill_img_input" @change="uploadQuillImg" accept="image/*"/>
    </div>

  </div>
</template>

<script>
import base from '@/api/common';
import {quillEditor} from 'vue-quill-editor';
import 'quill/dist/quill.snow.css'

export default {
  name: "consultationManage",
  data() {
    return {
      active: 1,
      page: {
        current: 1,
        size: 10,
        total: 12,
        rows: [],
        name: '',
        status: null,
      },

      userPage: {
        current: 1,
        size: 8,
        total: 5,
        rows: [],

        mid: '',
      },
      userListDialog: false,

      editDialog: false,
      editDialogTitle: '',
      editModel: '',
      editForm: {
        id: '',
        title: '',
        subTitle: '',

        deadlineDate: '',
        meetPlace: '',
        briefDesc: '',
        thumbnailPath: '',
        explanation: '',

        doctors: [],

        dateRange: []
      },

      editorOption: { //  富文本编辑器配置
        theme: 'snow',
        placeholder: '请输入会诊说明文字',
      },
      uploadUrl: base.uploadUrl + "consultation",

      //doctorSelectDialog: false,
      doctors: [{id: 1, fullName: 'a', account: 123}],
      //selectedDoctors:[],

    }
  },
  components: {
    quillEditor
  },
  mounted() {
    this.changePageType(1);


  },
  methods: {
    skipPage(current) {
      this.page.current = current;
      let reqData = {
        page: this.page.current,
        size: this.page.size,
        name: this.page.name,
        status: this.page.status == null ? '' : this.page.status
      };
      this.$ajax.get(base.manager_api.expert.consultation.page, {params: reqData}).then(res => {
        if (res.data.status === 'success') {
          this.page.current = res.data.current;
          this.page.size = res.data.size;
          this.page.total = res.data.total;
          this.page.rows = res.data.rows;
        }
      })
    },
    skipUserPage(current) {
      if (this.userPage.mid) {
        let that = this;
        this.userPage.current = current;
        this.$ajax.get(base.manager_api.expert.register.page.replace("{id}", this.userPage.mid), {
          params: {
            page: that.userPage.current,
            size: that.userPage.size,
          }
        }).then(res => {
          if (res.data.status === 'success') {
            this.userPage.current = res.data.current;
            this.userPage.size = res.data.size;
            this.userPage.total = res.data.total;
            this.userPage.rows = res.data.rows;
          }
        })
      }
    },
    changePageType(active, status) {
      this.active = active;
      if (status != null) {
        this.page.status = status;
      } else {
        this.page.status = '';
      }
      this.skipPage(1);
    },
    changeStatus(row) {
      if (row) {
        let targetStatus = (row.status + 1) % 2;
        let msg = "确定要" + (targetStatus === 0 ? "取消" : "") + "发布吗?";
        this.$messageBox.confirm(msg, '提示', {type: 'warning'}).then(_ => {
          this.$ajax.post(base.manager_api.expert.consultation.changeStatus.replace("{id}", row.id) + "?status=" + targetStatus).then(res => {
            if (res.data.status === 'success') {
              row.status = targetStatus;
              this.$message.success(res.data.message);
            } else {
              this.$message.error(res.data.message);
            }
          }).catch((err) => {
            console.error(err)
            this.$message.error("操作失败");
          })
        });
      }
    },
    showRegister(item) {
      if (item && item.id) {
        if (item.registerCount == 0) {
          this.$message.warning("还没有人报名!");
          return;
        }
        this.userListDialog = true;
        this.userPage.mid = item.id;
        this.skipUserPage(1);
      }
    },
    toDetails(id) {
      window.open("/admin/consultationDetails/" + id, '_blank')
    },
    del(id) {
      let that = this;
      this.$messageBox.confirm("确认要删除吗?", '删除确认', {type: 'warning'}).then(_ => {
        that.$ajax.post(base.manager_api.expert.consultation.del.replace("{id}", id)).then(res => {
          if (res.data.status === 'success') {
            that.$message.success("删除成功");
            that.removeItemById(id);
          } else {
            that.$message.error(res.data.message);
          }
        }).catch(err => {
          console.error(err);
          this.$message.error("操作失败");
        })
      })
    },
    clearForm() {
      this.editForm.title = '';
      this.editForm.subTitle = '';
      this.editForm.deadlineDate = '';
      this.editForm.meetPlace = '';
      this.editForm.briefDesc = '';
      this.editForm.thumbnailPath = '';
      this.editForm.explanation = '';
      this.editForm.dateRange = [];
      this.editForm.doctors.length = 0;
    },
    handleOpen() {
      this.$ajax.get(base.api.doctor.baseAll).then(res => {
        if (res.data.status === 'success') {
          this.doctors = res.data.list;
        }
      });
    },
    toEdit(id) {
      this.editDialogTitle = '编辑会诊';
      this.editDialog = true;
      this.editModel = 'edit';
      this.editForm.id = id;
      // 回显信息
      this.$ajax.get(base.manager_api.expert.consultation.details.replace("{id}", id)).then(res => {
        if (res.data.status === 'success') {
          if (res.data.data) {
            this.editForm.title = res.data.data.title;
            this.editForm.subTitle = res.data.data.subTitle;
            this.editForm.deadlineDate = new Date(res.data.data.deadlineDate);
            this.editForm.meetPlace = res.data.data.meetPlace;
            this.editForm.briefDesc = res.data.data.briefDesc;
            this.editForm.thumbnailPath = res.data.data.thumbnailPath;
            this.editForm.explanation = res.data.data.explanation;
            this.editForm.dateRange = [new Date(res.data.data.meetStartDate), new Date(res.data.data.meetEndDate)];
            if (res.data.data.doctors && res.data.data.doctors.length !== 0) {
              this.editForm.doctors = res.data.data.doctors.map((o, i, arr) => {
                return o.id
              });
            } else {
              this.editForm.doctors.length = 0;
            }
          }
        } else {
          this.$message.error("信息加载失败!");
        }
      }).catch(err => {
        this.$message.error("信息加载失败!");
      });
    },
    addConsultation() {
      this.editDialogTitle = '新增会诊';
      this.editDialog = true;
      this.editModel = 'add';
    },
    quillEditorReadyHandle() {
      let that = this;
      // 更改初始的 上传图片行为
      this.$refs['myQuillEditor'].quill.getModule('toolbar').addHandler('image', function () {
        $("#quill_img_input").click();
      })
    },
    uploadQuillImg() {
      let imageFile = $("#quill_img_input")[0].files[0];
      if (!(imageFile && imageFile.type)) {
        return;
      }
      if (imageFile.type.toString().indexOf("image") === -1) {
        this.$message.error("请选择图片文件");
        return;
      }
      let formData = new FormData();
      formData.append("up`loadFile", imageFile);

      this.$ajax.post(this.uploadUrl, formData).then(res => {
        if (res.data.status === 'success') {
          // insert quill
          let quillEditor = this.$refs['myQuillEditor'].quill;
          quillEditor.insertEmbed(quillEditor.selection.savedRange.index, 'image', res.data.message);
        } else {
          this.$message.error("图片上传失败!");
        }
      }).catch((err) => {
        console.log(err)
        this.$message.error("图片上传失败")
      });
    },
    removeItemById(id) {
      if (id) {
        let index = -1;
        $(this.page.rows).each((i, o) => {
          if (id == o.id) {
            index = i;
            return false;
          }
        });
        if (index >= 0) {
          this.page.rows.splice(index, 1);
        }
      }
    },
    handleUploadSuccess(res, file, fileList) {
      if (res.status === 'success') {
        this.editForm.thumbnailPath = res.message;
      } else {
        this.$message.error("图片上传失败");
        this.editForm.thumbnailPath = "";
      }
    },
    handleUploadError(event, file, fileList) {
      this.$message.error("图片上传失败");
      this.editForm.thumbnailPath = "";
    },
    save() {
      if ($.trim(this.editForm.title).length === 0) {
        this.$message.warning("标题不能为空");
        return;
      }
      if ($.trim(this.editForm.thumbnailPath).length === 0) {
        this.$message.warning("缩略图不能为空");
        return;
      }
      if (this.editForm.dateRange.length !== 2) {
        this.$message.warning("会诊时间选择错误");
        return;
      }
      if (!this.editForm.deadlineDate) {
        this.$message.warning("会诊截止时间不能为空");
        return;
      }
      // 时间判断
      if (this.editForm.dateRange[0].getTime() < this.editForm.deadlineDate.getTime()) {
        this.$message.warning("截止时间应在开始时间之前");
        return;
      }
      let reqData = {
        title: this.editForm.title,
        subTitle: this.editForm.subTitle,
        thumbnailPath: this.editForm.thumbnailPath,
        meetStartDate: this.editForm.dateRange[0].Format("yyyy/MM/dd HH:mm:ss"),
        meetEndDate: this.editForm.dateRange[1].Format("yyyy/MM/dd HH:mm:ss"),
        deadlineDate: this.editForm.deadlineDate.Format("yyyy/MM/dd HH:mm:ss"),
        meetPlace: this.editForm.meetPlace,
        briefDesc: this.editForm.briefDesc,
        explanation: this.editForm.explanation,
        doctors: this.editForm.doctors.map((o, i, arr) => {
          return {id: o}
        })
      };
      let url = '';
      if (this.editModel === 'add') {
        url = base.manager_api.expert.consultation.add;
      } else if (this.editModel === 'edit') {
        url = base.manager_api.expert.consultation.update.replace("{id}", this.editForm.id);
      }
      let that = this;
      this.$ajax.post(url, reqData).then(res => {
        if (res.data.status === 'success') {
          that.$message.success('保存成功');
          that.editDialog = false;
          that.changePageType(3, 0);
        } else {
          that.$message.error(res.data.message)
        }
      }).catch((err) => {
        console.error(err)
        that.$message.error("操作失败");
      });
    }

  },
  filters: {
    dateFmt(date, pattern) {
      if (date) {
        if (!pattern) {
          pattern = "yyyy-MM-dd HH:mm";
        }
        return new Date(date).Format(pattern);
      }
      return "-";
    },
    statusFmt(status) {
      if (status || status == 0) {
        if (status == 0) {
          return "未发布";
        } else if (status == 1) {
          return "已发布";
        }
      }
      return "-";
    }
  }
}
</script>

<style scoped lang="scss">

@import '../../../assets/css/admin.scss';

div[data-state] {
  cursor: pointer
}

div[data-state='1'] {
  color: #a4da89;
  background-color: #f0f9eb;
  border-color: #e1f3d8;
}

div[data-state='0'] {
  color: #f9a7a7;
  background-color: #fef0f0;
  border-color: #fde2e2;
}


::v-deep div.el-dialog {
  .el-dialog__body {
    max-height: calc(100vh - 280px) !important;
    min-height: 100px;
    overflow-y: scroll;
  }
}

::v-deep .el-dialog__wrapper {
  overflow: unset
}

::v-deep .ql-snow .ql-picker.ql-header .ql-picker-label::before, .ql-snow .ql-picker.ql-header .ql-picker-item::before {
  position: relative;
  top: -8px
}


.el-select {
  width: 50%
}

.el-select__tags {
  max-width: unset !important;
}

.addART {
  margin-left: 20px
}
</style>